const StringUtils = {
    clearHTML: (message) => {
        let parser = new DOMParser();
        let dom = parser.parseFromString("<!doctype html><body>" + message, "text/html");
        return dom.body.textContent;
    },
};

export default StringUtils;
